const BenefitCard = ({ icon: Icon, title, description }) => {
  return (

    <div className=" p-6 relative border border-teal-600 rounded rounded-ss-2xl inline cursor-pointer text-4xl before:bg-teal-600 
    hover:rounded-b-none before:absolute before:-bottom-0 before:-left-0  before:block before:h-[4px] before:w-full before:origin-bottom-right
     before:scale-x-0 before:transition before:duration-300 before:ease-in-out hover:before:origin-bottom-left hover:before:scale-x-100
     bg-gradient-animated ">
      
      <div className="flex items-center gap-4 text-primary">
        <div className="text-3xl lg:text-4xl ">
          <Icon />
        </div>
        <h3 className="text-base sm:text-md font-semibold">
          {title}
        </h3>
      </div>

      <p className="text-sm text-gray-400 mt-4">
        {description}
      </p>
      
    </div>
  );
};

export default BenefitCard;
